import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

interface Props extends SvgIconProps {
  fill?: string;
}

const IconAllChecked: React.FC<Props> = ({ fill, ...other }) => (
  <SvgIcon width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...other}>
    <rect width="19" height="19" rx="2" fill="#CDE7ED" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.8586 12.7452L15.8333 6.77054L14.4191 5.35632L8.44439 11.331L5.63638 8.52299L4.22217 9.9372L7.03018 12.7452L8.44439 14.1594L9.8586 12.7452Z"
      fill="black"
    />
  </SvgIcon>
);

export default IconAllChecked;
